import { createContext } from 'react';

const alertContext = createContext({
    alerts:[{}] ,
    setError: (msg = '', type = '') => {},
});

export default alertContext;
